/** Giro3D version. */
const VERSION = 'latest';
export default VERSION;